import { type ThemeConfig, theme } from 'antd';

export type NavTheme = 'light' | 'realDark';

const NAV_THEME_STORAGE_KEY = 'app_nav_theme';
const DEFAULT_NAV_THEME: NavTheme = 'realDark';

export function getStoredNavTheme(): NavTheme {
  if (typeof window === 'undefined') {
    return DEFAULT_NAV_THEME;
  }

  const saved = window.localStorage.getItem(NAV_THEME_STORAGE_KEY);
  return saved === 'light' || saved === 'realDark' ? saved : DEFAULT_NAV_THEME;
}

export function getShellTheme(navTheme: string, scope = 'root'): ThemeConfig {
  const dark = navTheme === 'realDark';
  return {
    inherit: false,
    algorithm: dark ? theme.darkAlgorithm : theme.defaultAlgorithm,
    cssVar: { key: `app-${scope}-${dark ? 'dark' : 'light'}` },
    token: {
      fontFamily: 'AlibabaSans, sans-serif',
      borderRadius: 8,
      colorBgLayout: dark ? '#121212' : '#ffffff',
      colorTextPlaceholder: dark ? '#a6a6a6' : '#667085',
    },
    components: {
      Button: {
        defaultBorderColor: 'transparent',
        defaultHoverBorderColor: 'transparent',
        defaultActiveBorderColor: 'transparent',
        defaultShadow: 'none',
        primaryShadow: 'none',
        dangerShadow: 'none',
      },
    },
  };
}

export function ensureInitialNavTheme(): NavTheme {
  const navTheme = getStoredNavTheme();

  if (typeof window !== 'undefined') {
    if (window.localStorage.getItem(NAV_THEME_STORAGE_KEY) !== navTheme) {
      window.localStorage.setItem(NAV_THEME_STORAGE_KEY, navTheme);
    }
    document.documentElement.dataset.navTheme = navTheme;
  }

  return navTheme;
}
